import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import { BiData } from '@wix/da-bi/pkg/events';
import s from './EmptyWatchedGroups.scss';
const EmptyWatchedGroups = (props)=>{
    const { t } = useTranslation();
    const { isLoggedIn } = useContext(SessionContext);
    if (isLoggedIn) {
        return /*#__PURE__*/ React.createElement("div", {
            className: s['groups-empty']
        }, /*#__PURE__*/ React.createElement("div", {
            className: s['watch-groups']
        }, t('networkBar.groups.empty.header')), /*#__PURE__*/ React.createElement("div", {
            className: s['but-why']
        }, t('networkBar.groups.empty.text')));
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['groups-empty'], s['anon'])
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['but-why']
    }, t('networkBar.groups.empty.anon.text')), /*#__PURE__*/ React.createElement(BrandedButton, {
        variant: "brand-green",
        size: "small",
        className: s['signup'],
        href: Url.joinLink(),
        biData: BiData({
            evid: 240,
            referral_info: ReferralType.ANON_NETWORKBAR
        })
    }, t('networkBar.groups.empty.anon.join')));
};
EmptyWatchedGroups.displayName = 'EmptyWatchedGroups';
export default EmptyWatchedGroups;

//# sourceMappingURL=EmptyWatchedGroups.js.map